module.exports = __webpack_public_path__ + "static/girlshome-41fce43faef1e7f613e00451a4efaf66.jpeg";